import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/grupos/models";
import models from "../../models/grupos/models";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    models: [],
    new: [],
    edit: [],
    deleteItem: [],
    showAdd: false,
    openModels: false,
    mode: "Agregar modelo",
    openDelete: false,
  },

  mutations: {
    setModels(state, data) {
      state.models = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },

    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setShowAdd(state, data) {
      state.showAdd = data;
    },

    setNew(state, data) {
      state.new = data;
    },
    setOpenModels(state, data) {
      state.openModels = data;
    },
    setMode(state, data) {
      state.mode = data;
    },

    setOpenDelete(state, data) {
      state.openDelete = data;
    },
  },
  actions: {
    async getModels(state, id) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getModels(id);

          state.commit("setModels", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.edit).then(() => {
            let item = state.state.edit;
            let options = state.state.models;

            options = options.map((option) => {
              if (option.id != item.id) {
                return option;
              }
              let fecHastaFormatted = item.to
                ? moment.utc(item.to, "YYYY-MM-DD").format("YYYY-MM-DD")
                : "";
              item = models.fromJson({
                liqModeloId: item.id,
                grupoId: item.groupId,
                fecDesde: item.from,
                fecHasta: fecHastaFormatted,
                nomLiqModelo: item.name,
              });
              return item;
            });

            state.commit("setModels", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    async new(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.new(state.state.new).then(({ data }) => {
            let item = state.state.new;
            let options = state.state.models;
            let newItem = models.fromJson({
              liqModeloId: item.id,
              grupoId: item.groupId,
              fecDesde: item.from,
              fecHasta: data.fecHasta,
              nomLiqModelo: item.name,
            });
            options.push(newItem);

            state.commit("setModels", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.deleteItem).then(() => {
            let options = state.state.models;

            options = options.filter((option) => {
              return option.id != state.state.deleteItem.id;
            });
            state.commit("setModels", options);
            resolve(true);
          });
        } catch (error) {
          console.log(error);
          reject(error);
        }
      });
    },
  },
});
